import { Component, OnDestroy, OnInit } from "@angular/core";
import moment from "moment-timezone";
import { Subscription } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-style-setup",
	templateUrl: "./style-setup.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class StyleSetupComponent implements OnInit, OnDestroy {
	cartIconOptions: {
		label: string;
		value: string;
	}[] = [
		{
			label: "burger & soda",
			value: "burger-soda",
		},
		{
			label: "burrito",
			value: "burrito",
		},
		{
			label: "fork & knife",
			value: "utensils",
		},
		{
			label: "french fries",
			value: "french-fries",
		},
		{
			label: "hamburger",
			value: "hamburger",
		},
		{
			label: "pizza",
			value: "pizza-slice",
		},
		{
			label: "pie",
			value: "pie",
		},
		{
			label: "sandwich",
			value: "sandwich",
		},
		{
			label: `shopping cart`,
			value: "shopping-cart",
		},
		{
			label: "steak",
			value: "steak",
		},
		{
			label: "taco",
			value: "taco",
		},
	];

	changesToSave: boolean = false;

	loaded: boolean = false;

	moment: any = moment;

	timestamp;
	timezones: any[] = [];

	venueKey: number;
	venueChangeSubscription: Subscription;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private localStorage: LocalDataStoreService,
		public venueSvc: OOVenueService,
		public userService: UserService
	) {}

	ngOnInit(): void {
		this.init();
		this.cartIconOptions.sort((a, b) => (a.label < b.label ? 1 : -1));
	}

	ngOnDestroy() {}

	async init() {}

	onSave() {
		this.venueSvc.ooVenueStyleSave(this.venueSvc.ooVenue.styles);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `App Style preferences saved successfully.` });
	}
}
